<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <a v-on="on">Forgotten Password?</a>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Reset Password</span>
      </v-card-title>
      <v-form ref="form" v-model="valid" @submit.prevent="sendPasswordReset">
        <v-card-text>
          Please enter your email address below and we'll send you a link to
          reset your password.
          <v-text-field
            class="mt-4"
            v-model="emailAddress"
            :rules="[rules.required, rules.emailAddress]"
            label="Email Address"
            type="email"
            required
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            type="button"
            color="blue darken-1"
            text
            @click="dialog = false"
            >Close</v-btn
          >
          <v-btn type="submit" color="blue darken-1" text>Send</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from '../services/ApiService.js'
import object from '../services/Objects.js'
import Validation from '@/mixins/validation.js'

export default {
  name: 'ForgottenPassword',
  mixins: [Validation],
  data() {
    return {
      dialog: false,
      valid: true,
      emailAddress: ''
    }
  },
  computed: {
    resetUrl() {
      if (process.env.NODE_ENV !== 'production') {
        return 'localhost:8080/#/password-reset/'
      } else {
        return 'https://marex-dp-solutions-web.azurewebsites.net/#/password-reset/'
      }
    }
  },
  methods: {
    sendPasswordReset() {
      if (this.$refs.form.validate()) {
        var model = {
          emailAddress: this.emailAddress
        }
        ApiService.post(object.User + '/sendpasswordreset', model).then(() => {
          this.dialog = false
        })
      }
    }
  },
  watch: {
    dialog: function() {
      if (!this.dialog) {
        this.$refs.form.reset()
      }
    }
  }
}
</script>

<style scoped></style>
